// extracted by mini-css-extract-plugin
module.exports = {"buttonBordered":"button-bordered-module--button-bordered--3uTS4"};